import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend,
  LabelList,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;

    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "12px",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
        }}
      >
        <h6
          style={{
            fontWeight: 600,
            marginTop: 0,
            marginBottom: "8px",
            color: "#333",
            borderBottom: "1px solid #eee",
            paddingBottom: "6px",
          }}
        >
          {data.districtName}
        </h6>
        <div style={{ fontSize: "13px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "6px",
            }}
          >
            <span style={{ color: "#666", marginRight: "24px" }}>
              Total Paid:
            </span>
            <span style={{ fontWeight: 600, color: "#015198" }}>
              RWF {data.formattedTotal}
            </span>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default function SalariesByDistrictChart({ data }) {
  const totalAllDistricts = data.reduce((sum, item) => sum + item.totalPaid, 0);

  const processedData = data
    .map((item) => ({
      ...item,
      formattedTotal: new Intl.NumberFormat("en-US").format(item.totalPaid),
      totalInBillions: (item.totalPaid / 1000000000).toFixed(2),
      percentageOfTotal: ((item.totalPaid / totalAllDistricts) * 100).toFixed(
        1
      ),
      shortName:
        item.districtName?.length > 12
          ? `${item.districtName.substring(0, 10)}...`
          : item.districtName,
    }))
    .sort((a, b) => b.totalPaid - a.totalPaid);

  if (processedData.length === 0) {
    return (
      <div className="p-4 text-center">
        No data available for district salaries comparison
      </div>
    );
  }

  return (
    <div className="w-100">
      <ResponsiveContainer
        width="100%"
        height={1000}
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <BarChart
          data={processedData}
          layout="vertical"
          margin={{ top: 10, right: 10, left: -30, bottom: 10 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
          />
          <XAxis
            type="number"
            tickFormatter={(value) => `RWF ${(value / 1000000000).toFixed(1)}B`}
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#666", fontSize: 12 }}
            domain={[0, (dataMax) => Math.max(dataMax * 2, 100000000)]}
          />
          <YAxis
            type="category"
            dataKey="districtName"
            width={150}
            orientation="left"
            tick={{
              textAnchor: "start",
              dx: -95,
              fontSize: 14,
            }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) =>
              value?.length > 15 ? `${value.substring(0, 12)}...` : value
            }
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="totalPaid"
            fill="hsl(var(--chart-1))"
            name="Total Salaries"
            barSize={16}
          >
            <LabelList
              dataKey="formattedTotal"
              position="right"
              formatter={(value) => `RWF ${value}`}
              style={{
                fontWeight: "bold",
                fontSize: 13,
                fill: "black",
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
